import React, { useState } from 'react';
import { Card, CardMedia, Box } from '@mui/material';
import withImagePreview from './withImagePreview';

export const StyledCard: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Card
    sx={{
      background: 'transparent',
      border: '1px solid #fff2',
      boxShadow: 'none',
      borderRadius: 2,
      overflow: 'hidden',
      mb: 2,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    {children}
  </Card>
);

export const ImageWithFallback: React.FC<{
  src: string;
  alt: string;
  identifier?: string;
  style?: React.CSSProperties;
}> = ({ src, alt, identifier, style }) => {
  const [error, setError] = useState(false);
  return (
    <Box sx={{ width: '100%', height: '100%', maxHeight: '20rem', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#222' }}>
      {!error ? (
        <CardMedia
          component="img"
          image={src}
          alt={alt}
          sx={{
            objectFit: 'contain',
            width: '100%',
            height: '100%',
            maxHeight: '20rem',
            ...style,
          }}
          onError={() => setError(true)}
          data-testid={identifier}
        />
      ) : (
        <Box sx={{ color: '#888', fontSize: 16, textAlign: 'center', width: '100%', background: '#f5f5f5', height: '100%', maxHeight: '20rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          Image unavailable
        </Box>
      )}
    </Box>
  );
};

export const ImageWithPreview = withImagePreview(ImageWithFallback);
